export default __webpack_public_path__ + "static/media/bg_gray_logo.c0915ce7.png";